<template>
  <div class="style-total-row p-2 d-flex justify-content-end">
    <div class="p-2 me-5 fs-5 scss-title">
      {{ title }}
    </div>

    <div class="p-2 fs-5 scss-title scss-text-blue">
      {{ total }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TotalRow",
  props: {
    title: String,
    total: String,
  },
};
</script>

<style lang="scss" scoped>
.style-total-row {
  font-size: $large-font-size;
}
</style>
